module.exports = __webpack_public_path__ + "img/icon-btn-facebook1.e08e0a0a.png";